import {
  Collapsible,
  ModelForm, ModelInput, ModelNewNumericInput,
  useStyledTheme,
} from '@equifinance/shared';
import styled from 'styled-components';
import { checkInsolvencyIsSettled, Insolvency, useCreditContext } from '../../../../contexts/credit';
import { CreditDetailsRow } from '../../CreditDetails/CreditDetails';

const ConsolidationInputRow = styled(CreditDetailsRow)` ${({ theme }) => `
  gap: ${theme.padding[4]};
`}`;

export default function ConsolidationInsolvencyDetails({ data }: { data: Insolvency }) {
  const { updateInsolvencyItem, credit } = useCreditContext();
  const { errors, warnings } = credit;
  const theme = useStyledTheme();
  const { consolidationType, ignored } = data;

  const update = (values: any, disableIncrementUpdateCount: boolean = false) => updateInsolvencyItem(
    values,
    data.id,
    disableIncrementUpdateCount,
  );

  if (
    ignored
    || !consolidationType
    || consolidationType === 'NoConsolidation'
    || checkInsolvencyIsSettled(data)
  ) {
    return null;
  }

  return (
    <ModelForm model={data} update={update} errors={errors} warnings={warnings}>
      <Collapsible
        id={`${data.id}-consolidation-details`}
        title="Consolidation details"
        level={2}
      >
        <ConsolidationInputRow>
          <ModelInput
            field="consolidationPayeeName"
            label="Third party"
            required
          />
          <ModelInput
            field="consolidationAccountNumber"
            label="Account no."
            containerCss={`
              max-width: ${theme.padding[12]};
            `}
            required
            mutateValue={(v) => v?.replace(/\D/g, '')?.slice(0, 8) ?? ''}
          />
          <ModelInput
            field="consolidationSortCode"
            label="Sort code"
            containerCss={`
              max-width: ${theme.padding[11]};
            `}
            required
            mutateValue={(v) => v?.replace(/\D/g, '')?.slice(0, 6) ?? ''}
          />
          <ModelInput
            field="consolidationReferenceNumber"
            label="Reference"
            required
          />
          <ModelNewNumericInput
            field="consolidatedAmount"
            label="Consolidated Amount (£)"
            prefix="£"
            isFixedDecimal
            required
          />
        </ConsolidationInputRow>
      </Collapsible>
    </ModelForm>
  );
}
